// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import 'slick-carousel/slick/slick.min';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

//usps slider in de header
$('.header-swiper').slick({
  infinite: true,
  autoplay: true,
  arrows: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
});

//producten slider
$('.product-swiper').slick({
  infinite: false,
  autoplay: false,
  dots: true,
  arrows: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings:
        {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
      },
    },
  ],
});

//gallery slider op product pagina
$('.pdp-slider').slick({
  infinite: false,
  autoplay: false,
  dots: false,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
});

//custom function showing current slide
var $status = $('.pagingInfo');
var $slickElement = $('.pdp-slider');

$slickElement.on('init reInit afterChange', function (event, slick, currentSlide) {
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  var i = (currentSlide ? currentSlide : 0) + 1;
  $status.text(i + '/' + slick.slideCount);
});

//Input plus-minus buttons voor single product & cart
function incrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(
    parent.find('input[name="' + fieldName + '"]').val(),
    10
  );

  if (!isNaN(currentVal)) {
    parent
      .find('input[name="' + fieldName + '"]')
      .val(currentVal + 1)
      .trigger('change');
  } else {
    parent.find('input[name="' + fieldName + '"]').val(0);
  }
}

function decrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(
    parent.find('input[name="' + fieldName + '"]').val(),
    10
  );

  if (!isNaN(currentVal) && currentVal > 0) {
    parent
      .find('input[name="' + fieldName + '"]')
      .val(currentVal - 1)
      .trigger('change');
  } else {
    parent.find('input[name="' + fieldName + '"]').val(0);
  }
}

$(document).on('click', '.button-plus', function (e) {
  incrementValue(e);
});

$(document).on('click', '.button-minus', function (e) {
  decrementValue(e);
});

//update cart on quantity change
var timeout;
$('.pane--cart').on('change', 'input.qty', function () {
  if (timeout !== undefined) {
    clearTimeout(timeout);
  }
  $('.update-cart-button').removeAttr('disabled');

  timeout = setTimeout(function () {
    $('[name="update_cart"]').trigger('click');
    $(document.body).trigger('wc_fragment_refresh');
  }, 1000); // 1 second delay, half a second (500) seems comfortable too
});

if (!$('body.single-product')) {
  jQuery(function ($) {
    $('.woocommerce').on('change', 'input.qty', function () {
      if (timeout !== undefined) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        $('[name="update_cart"]').trigger('click');
        document.location.reload(true);
      });
    });
  });
}

let searchParams = new URLSearchParams(window.location.search)
if (searchParams.has('wederverkoper')) {
  $('.istrigger').find('input:checkbox').prop( "checked", true );
}

$(document).ready(function () {
  var cartcount = $('.cart-count').text();
  if (cartcount === '0') {
    $('.cart-count').css('opacity', '0');
  }

  if (screen.width < 1200) {
    $('.filterbutton').click(function () {
      $('.filters-wrapper ').toggleClass('filters-open');
      $('.filters-underlay').toggleClass('is-open');
    });

    $('.exit-filters').click(function () {
      $('.filters-wrapper ').toggleClass('filters-open');
      $('.filters-underlay').toggleClass('is-open');
    });
  }

  $('.hamburger-button').click(function () {
    $('.products-menu').toggleClass('menu-open');
  });

  $('.account-nav-hamburger').click(function () {
    $('.nav-wrapper').toggleClass('account-nav-open');
    $(this).toggleClass('burger-open');
  });

  //SWAP BETWEEN LOGIN AND REGISTER
  $('.register-block-swapper').click(function(){
    $('.login-col').each(function() {
      $(this).toggleClass('block-open');
    })
  });

  $('.description-title').click(function () {
    $('.description-wrapper').toggleClass('is-open');
    $(this).toggleClass('is-open');
  });

  $('.specs-title').click(function () {
    $('.specs-wrapper').toggleClass('is-open');
    $(this).toggleClass('is-open');
  });

  $('.exit-products').click(function () {
    $('.products-menu').toggleClass('menu-open');
  });

  $('.products-menu').find('.menu-item-has-children').click(function () {
    $(this).toggleClass('sub-menu-open');
    $('.products-menu').toggleClass('menu-open');
  });

  $('.submenu-title').click(function () {
    $(this).parent().toggleClass('sub-menu-open');
  });

  $('.faq-title').click(function () {
    $(this).parent().toggleClass('faq-open');
  });
});

let pull_page = 1;
$('.loading-banner').click(function () {
  var posttype = '';
  var type = $(this).data('type');

  if (type === 'post') {
    posttype = 'posts';
  } else if (type === 'projecten') {
    posttype = 'projects';
  }

  let jsonFlag = true;
  if (jsonFlag) {
    jsonFlag = false;
    pull_page++;

    $.getJSON("/wp-json/" + posttype + "/all-posts?page=" + pull_page, function (data) {

      console.log(data);

      if (data.length) {
        var items = [];

        $.each(data, function (key, val) {
          const arr = $.map(val, function (el) {
            return el
          });
          const post_url = arr[1];
          const post_title = arr[3];
          var post_img = arr[4];
          var post_date = arr[5];
          var post_excerpt = arr[6];
          let day = post_date.slice(8, 10);
          let month = post_date.slice(5, 7);
          let year = post_date.slice(0, 4);
          let datefinal = day + '/' + month + '/' + year;

          if (!post_img) {
            post_img = window.location.origin + '/app/themes/devriendschap/dist/images/backup.jpg';
          }

          let item_string = '';
          if (type === 'post') {
            item_string = '<a href="' + post_url + '" class="news-card">' +
              '<span class="imgwrapper" style="background-image: url(' + post_img + ')"></span>' +
              '<div class="post-data">' +
                '<span class="date">' + datefinal + '</span>' +
                '<h4>' + post_title + '</h4>' +
              '<p>' + post_excerpt + '</p>' +
              '</span>' +
              '<span class="button button--tertiary">' + '<span>Lees meer</span>' + '</span>' +
              '</div>' +
              '</a>';
          } else if (type === 'projecten') {
            item_string = '<a href="' + post_url + '" class="project-card" style="background-image: url(' + post_img + ')"><span class="overlay-3"></span><h5>' + post_title + '</h5></a>';
          }

          items.push(item_string);
        });

        if (type === 'post') {
          if (data.length >= 6) {
            $('li.loader').fadeOut();
            $(".load-more-grid").append(items);
          } else {
            $(".load-more-grid").append(items);
            $('#project-loader').hide();
          }
        } else if (type === 'projecten') {
          if (data.length >= 15) {
            $('li.loader').fadeOut();
            $(".load-more-grid").append(items);
          } else {
            $(".load-more-grid").append(items);
            $('#project-loader').hide();
          }
        }
      } else {
        $('#project-loader').css('display', 'none');//hide();
      }
    }).done(function (data) {
      if (data.length) {
        jsonFlag = true;
      }
    });
  }
});



// WEBPACK FOOTER //
// ./scripts/main.js